export const shareContent = async ( title, url ) => {
    if (typeof android != "undefined"){
        android.shareContent(title, url);
        return { success: true, platform: 'android' };
    }else if (typeof webkit !== "undefined" && webkit.messageHandlers && webkit.messageHandlers.shareContent) {
        webkit.messageHandlers.shareContent.postMessage({ title, url });
        return { success: true, platform: 'ios-app' };
    }else{
        console.log(title)
        // Check if it's iOS webview (not Safari)
        const isIOSWebView = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                           !window.MSStream &&
                           !/(Safari|CriOS|FxiOS|OPiOS|mercury)/i.test(navigator.userAgent);

        if (navigator.share && !isIOSWebView) {
          try {
            await navigator.share({
              title: title,
              url: url
            });
            return { success: true, platform: 'browser' };
          } catch (error) {
            console.error(error);
            return { success: false, fallbackData: { title, url }, platform: 'browser-fallback' };
          }
        } else {
          // iOS webview fallback - return data for modal
          return { success: false, fallbackData: { title, url }, platform: 'ios-webview' };
        }
    }
}
